import { render, staticRenderFns } from "./bannersEditar.vue?vue&type=template&id=61e8ddfd&scoped=true&"
import script from "./bannersEditar.vue?vue&type=script&lang=js&"
export * from "./bannersEditar.vue?vue&type=script&lang=js&"
import style0 from "./bannersEditar.vue?vue&type=style&index=0&id=61e8ddfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e8ddfd",
  null
  
)

export default component.exports